<template>
    <v-flex xs12 mt-4>
        <v-card flat v-if="specialist.next_date" color="grey lighten-2" class="pa-2">
            <v-card-title primary-title>
                <div>
                    <div class="title mb-2 font-weight-light">Próxima hora disponible:</div>
                    <span class="font-weight-bold">{{dateFormat}}</span>
                </div>
            </v-card-title>

            <v-flex xs12 class="text-center text-sm-right">
                <v-btn @click="pickCurrent" dark color="accent">Seleccionar</v-btn>
                o
                <v-btn @click="more"  dark color="primary" :disabled="nextDisabled">Ver más</v-btn>
            </v-flex>

        </v-card>
    </v-flex>
</template>
<script>
    export default {
        name: 'NextDatePicker',
        props: ['specialist', 'onSelectCurrent', 'onSelectMore', 'nextDisabled'],
        methods: {
            pickCurrent(){
                var vm = this
                if(typeof vm.onSelectCurrent == 'function'){
                    vm.onSelectCurrent(vm.specialist.next_date)
                }
            },
            more(){
                var vm = this
                if(typeof vm.onSelectMore == 'function'){
                    vm.onSelectMore()
                }
            }
        },
        computed:{
            dateFormat(){

                var vm = this
                if(!vm.specialist.next_date) return '';

                var date = vm.$moment(vm.specialist.next_date.date).format('ddd') + ', ' +
                        vm.$moment(vm.specialist.next_date.date).format('D') + ' ' +
                        vm.$moment(vm.specialist.next_date.date).format('MMMM') + ' a las ' +
                        vm.specialist.next_date.interval.hour + ' Hrs.'


                return date.toUpperCase()
                //this.$moment(this.selectedDate).format('Y') + ''
            }
        }
    }
</script>
